const a = ":host{display:inline-block}.sl-badge{display:inline-flex;align-items:center;justify-content:center;white-space:nowrap;border-radius:var(--sl-radius-full);font-family:var(--sl-font-family-base);font-weight:var(--sl-font-weight-medium);line-height:1}.sl-badge--sm{height:1.25rem;padding:0 var(--sl-spacing-2);font-size:var(--sl-font-size-xs)}.sl-badge--md{height:1.5rem;padding:0 var(--sl-spacing-2);font-size:var(--sl-font-size-sm)}.sl-badge--lg{height:1.75rem;padding:0 var(--sl-spacing-3);font-size:var(--sl-font-size-base)}.sl-badge--default{background-color:hsl(var(--sl-hsl-primary));color:hsl(var(--sl-hsl-primary-foreground))}.sl-badge--secondary{background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-badge--success{background-color:hsl(var(--sl-hsl-success));color:var(--sl-white)}.sl-badge--error{background-color:hsl(var(--sl-hsl-destructive));color:hsl(var(--sl-hsl-destructive-foreground))}.sl-badge--warning{background-color:hsl(var(--sl-hsl-warning));color:var(--sl-white)}.sl-badge--info{background-color:hsl(var(--sl-hsl-info));color:var(--sl-white)}.sl-badge--outline{background-color:transparent;border:1px solid hsl(var(--sl-hsl-border));color:hsl(var(--sl-hsl-foreground))}";
class r extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "size"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._span = document.createElement("span"), this._render();
  }
  attributeChangedCallback(s, e, t) {
    e !== t && (this._updateBadge(), this._render());
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(s) {
    this.setAttribute("variant", s);
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(s) {
    this.setAttribute("size", s);
  }
  _updateBadge() {
    this._span.className = this._getBadgeClasses();
  }
  _getBadgeClasses() {
    return [
      "sl-badge",
      `sl-badge--${this.variant}`,
      `sl-badge--${this.size}`
    ].join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${a}</style>
      <span class="${this._getBadgeClasses()}">
        <slot></slot>
      </span>
    `, this._span = this._shadow.querySelector("span");
  }
}
typeof customElements < "u" && !customElements.get("sl-badge") && customElements.define("sl-badge", r);
export {
  r as SlBadgeElement
};
//# sourceMappingURL=sl-badge.js.map
